
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32Ecy", function(module, exports) {
/* CommentButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $1DWH0 = parcelRequire("1DWH0");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $gczDe = parcelRequire("gczDe");


var $k8e76 = parcelRequire("k8e76");


var $8i27m = parcelRequire("8i27m");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $24amZ = parcelRequire("24amZ");


var $f34lU = parcelRequire("f34lU");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $id4ij = parcelRequire("id4ij");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7W8i8 = parcelRequire("7W8i8");


var $7Sm4c = parcelRequire("7Sm4c");


var $aHcFH = parcelRequire("aHcFH");


var $lsxnT = parcelRequire("lsxnT");


var $liGyh = parcelRequire("liGyh");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $cZa7r = parcelRequire("cZa7r");


var $6mKj3 = parcelRequire("6mKj3");


var $jIlrR = parcelRequire("jIlrR");


var $6nmm4 = parcelRequire("6nmm4");


var $hzHOC = parcelRequire("hzHOC");

const $8c4374cc7c888870$var$HeaderCommentIconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDialogOpen: isDialogOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _p12f1osq _1ul91ul9",
            __cmplp.isDialogOpen && "_11q71i45",
            __cmplp.isDialogOpen ? "_1tjq15cr" : "_1tjq1kw7",
            __cmplp.isDialogOpen ? "_7fq11i45" : "_7fq17qp0",
            __cmplp.className
        ])
    });
});
const $8c4374cc7c888870$var$BUTTON_STYLE_OVERRIDE = {
    padding: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-025, 2px)"}`
};
const $8c4374cc7c888870$var$logger = (0, $7W8i8.getLogger)('comment-button'); /* As user scrolls down Content Header goes out of viewport. When user scrolls up slighlty we display
                                             Header elements in Sticky Wrapper. Using isElementInViewport to set position of Inline dialog
                                            to always be below the Comment Icon */ 
const $8c4374cc7c888870$export$a9fe23cfa43a7b55 = (commentButton)=>{
    if (commentButton) {
        if ((0, $id4ij.isElementInViewport)(commentButton)) return 'bottom-end';
        else return 'auto-end';
    } else return 'bottom-end';
}; /*  NOTE: This component is ONLY for the renderer comment button component
    *		  if you want to change the editor comment button behavior you can
    *		  find that code inside of confluence/next/packages/editor-main-buttons/src/MainButtons.tsx
    */ 
const $8c4374cc7c888870$export$3d8d29fb8a8873dc = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, isDataLoaded: isDataLoaded, isFabricPage: isFabricPage })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel, hideCommentsPanel: hideCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)(); // skip this query for fabric page
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $6nmm4.default), {
        variables: {
            pageId: contentId
        },
        fetchPolicy: isDataLoaded || window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        skip: isFabricPage
    });
    const [{ unresolvedInlineComments: rapUnresolvedInlineComments }] = (0, $k8e76.useInlineComments)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)(); /* Read data from graphql Query if not-fabric */ 
    const unresolvedInlineCommentAnnotations = (0, $42omo.useMemo)(()=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (orderedActiveAnnotationIdList ?? []).map((annotation)=>annotation.threadKey) : rapUnresolvedInlineComments ?? [], [
        orderedActiveAnnotationIdList,
        rapUnresolvedInlineComments
    ]);
    const inlineCommentsCount = isFabricPage ? unresolvedInlineCommentAnnotations.length : data?.comments?.count || 0;
    const unresolvedInlineComments = isFabricPage ? unresolvedInlineCommentAnnotations : data?.comments?.nodes || [];
    const [isDialogOpen, setDialogState] = (0, $42omo.useState)(false);
    const [isInlineCommentShown, setShowInlineComments] = (0, $42omo.useState)(false);
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const inlineCommentRef = (0, $42omo.useRef)(null);
    const commentButtonRef = (0, $42omo.useRef)(null);
    const isFirstClickRef = (0, $42omo.useRef)(true);
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)(); // handle button click for legacy editor
    (0, $42omo.useEffect)(()=>{
        if ((!isFabricPage ? data : true) && isDataLoaded && isFirstClickRef.current) {
            //only call this if it hasn't been clicked before
            handleCommentButtonClick();
            isFirstClickRef.current = false;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        isDataLoaded
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            //Setting to null, since when the component re-renders (when a New comment is added), we want to query the DOM again to get the First Inline comment by position.
            inlineCommentRef.current = null;
        }; /**
        * Have to explicitly disable the eslint rule to ensure the value gets reset to null
        * Saving an inline comment will trigger a re-fetch of `CommentButtonQuery` and a re-render of this component.
        */ 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inlineCommentRef.current
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.VIEW_PAGE_COMMENT_BUTTON_EXPERIENCE),
            id: contentId,
            attributes: {
                framework: isFabricPage ? (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER : (0, $24amZ.InlineCommentFramework).REACT
            }
        });
    }, [
        experienceTracker,
        contentId,
        isFabricPage
    ]); //Checks the DOM for the first Inline Comment by position with class valid.
    const getFirstMarkerRefByPosition = ()=>{
        //checks for both Fabric and Legacy annotations
        const annotations = [].slice.call(document.querySelectorAll(`[data-mark-annotation-type="inlineComment"],.inline-comment-marker`));
        if (isFabricPage) return annotations.find((item)=>item.getAttribute('data-mark-annotation-state') === 'active') || null;
        return annotations.find((item)=>item.classList.contains('inline-highlight')) || null;
    };
    const getClass = ()=>'inline-highlight';
    const renderFirstInlineComment = (elem)=>{
        // Handles case where when User clicks Icon and annotations are not yet in the DOM.
        if (!elem) toggleDialog();
        else if (elem && elem.classList.contains(getClass())) {
            /**
       * Checking class valid for edge case scenario in which User visits a page with a Single Inline Comment
       * and then deletes or resolves a Inline Comment.
       * Deleting comment removes class valid from the annotation
       */ if (!elem.classList.contains('active-highlight')) elem.click();
            if (elem.classList.contains('active-highlight')) (0, $aHcFH.scrollCommentIntoView)({
                commentElement: elem,
                isFabricPage: isFabricPage
            });
        } else /**
       * Does another check to see if there are any valid inline Comments on the Page.
       * Handles edge case where we have  multiple Inline comments on the Page and User deletes the first One.
       * In that case check the DOM to find the Next valid inline Comment and Render
       * If no valid Inline comment is found it will be handled by above logic
       */ renderFirstInlineComment(findFirstInlineComment());
    };
    const findFirstInlineComment = ()=>{
        const firstInlineCommentByPosition = getFirstMarkerRefByPosition();
        let markerRef = firstInlineCommentByPosition && (firstInlineCommentByPosition.getAttribute('data-id') || firstInlineCommentByPosition.getAttribute('data-ref'));
        if (isFabricPage) markerRef = firstInlineCommentByPosition && firstInlineCommentByPosition.getAttribute('id');
         //Check against graphql response to make sure data integrity between DOM and back-end
        const isAnnotationInAnnotationList = markerRef && Boolean(unresolvedInlineComments.find((item)=>{
            if (isFabricPage) return item === markerRef;
            else {
                const location = item?.location;
                return location?.inlineMarkerRef === markerRef;
            }
        })) || false;
        if (isAnnotationInAnnotationList) {
            //store using useRef to avoid multiple function calls.
            inlineCommentRef.current = firstInlineCommentByPosition;
            return firstInlineCommentByPosition;
        }
        return null;
    };
    const toggleDialog = ()=>{
        setDialogState(!isDialogOpen);
        fireScreenEvent();
        experienceTracker.succeed({
            name: (0, $irVI7.VIEW_PAGE_DISCOVER_INLINE_COMMENTS_FEATURE_EXPERIENCE),
            attributes: {
                pageHasInlineComments: false
            }
        });
    }; //Screen Event when we display Dialog to show Users how to add Inline comments
    const fireScreenEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'commentsOnboardingScreen',
                attributes: {
                    type: 'header-button'
                }
            }
        }).fire();
    };
    const fireUIEvent = (pageHasInlineComments, shouldShow)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'inlineCommentsIcon',
                attributes: {
                    pageHasInlineComments: pageHasInlineComments,
                    icontype: 'header',
                    context: 'default',
                    newState: shouldShow ? 'showComments' : 'hideComments'
                },
                objectType: 'page',
                objectId: contentId,
                source: 'viewPageScreen'
            }
        }).fire();
    };
    const checkUnsavedAndHandleCommentButtonClick = ()=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                handleCommentButtonClick();
            }
        });
        else handleCommentButtonClick();
    };
    const handleCommentButtonClick = ()=>{
        if (isFabricPage) {
            if (isCommentsPanelShown) hideCommentsPanel();
            else {
                // FABRIC PAGES
                // Close the view component if it's open
                if (viewProps) {
                    // Inform the Renderer to de-select the annotation
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
                    setViewProps(null);
                }
                if (selectionProps) {
                    selectionProps.onClose();
                    setSelectionProps(null);
                }
                if (hoverProps) {
                    hoverProps.onClose();
                    setHoverProps(null);
                } // LEGACY PAGES
                if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
                window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
                showCommentsPanel();
            }
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.VIEW_PAGE_DISCOVER_INLINE_COMMENTS_FEATURE_EXPERIENCE),
            attributes: {
                framework: isFabricPage ? (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER : (0, $24amZ.InlineCommentFramework).REACT
            }
        });
        const pageHasUnresolvedInlineComments = Boolean(inlineCommentsCount && unresolvedInlineComments.length > 0);
        if (pageHasUnresolvedInlineComments) try {
            const firstInlineComment = inlineCommentRef.current || findFirstInlineComment();
            if (isFabricPage && firstInlineComment?.id) {
                removeCommentQueryParams();
                const commentElement = document.getElementById(`${firstInlineComment?.id}`);
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        firstInlineComment?.id
                    ],
                    eventTarget: commentElement
                });
                (0, $aHcFH.scrollCommentIntoView)({
                    commentElement: commentElement,
                    isFabricPage: true
                });
            } else renderFirstInlineComment(firstInlineComment);
             // Fire UI event for button click in view mode with inline comments
            fireUIEvent(pageHasUnresolvedInlineComments, !isInlineCommentShown);
            setShowInlineComments(!isInlineCommentShown);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DISCOVER_INLINE_COMMENTS_FEATURE_EXPERIENCE),
                error: error,
                attributes: {
                    pageHasInlineComments: true
                }
            });
            $8c4374cc7c888870$var$logger.error`An Error occured when computing to search for first Unresolved Inline comment`;
        }
        else {
            // Fire UI event for button click without inline comments
            fireUIEvent(pageHasUnresolvedInlineComments, !isDialogOpen);
            toggleDialog();
        }
    };
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        style: $8c4374cc7c888870$var$BUTTON_STYLE_OVERRIDE
    });
    else if (error && (0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error); //Abort Experience for anonymous users and don't display Comment Button
        // We have a known error with Comments API that does not handle anonymous Users
        //https://product-fabric.atlassian.net/browse/WS-1759
        experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_COMMENT_BUTTON_EXPERIENCE),
            reason: 'Anonymous user'
        });
        return null;
    }
    const getCommentIcon = (triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8c4374cc7c888870$var$HeaderCommentIconContainer, {
            isDialogOpen: isDialogOpen,
            "data-cy": "comment-button",
            ref: commentButtonRef,
            "data-testid": contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hzHOC.CommentIcon), {
            triggerProps: triggerProps,
            intl: intl,
            handleCommentButtonClick: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager') ? checkUnsavedAndHandleCommentButtonClick : handleCommentButtonClick
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        messageType: "engagement",
        messageId: "comment-button-component",
        isOpen: isDialogOpen,
        content: (0, $f34lU.inlineCommentGifContent),
        trigger: (triggerProps)=>getCommentIcon(triggerProps),
        placement: $8c4374cc7c888870$export$a9fe23cfa43a7b55(commentButtonRef.current),
        onClose: ()=>{
            toggleDialog();
        },
        shouldRenderToParent: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_COMMENT_BUTTON_EXPERIENCE)
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
});
const $8c4374cc7c888870$export$44a3d5aec3da3e9f = (0, $1DWH0.default)()($8c4374cc7c888870$export$3d8d29fb8a8873dc);
module.exports["getPlacement"] = $8c4374cc7c888870$export$a9fe23cfa43a7b55;
module.exports["CommentButtonComponent"] = $8c4374cc7c888870$export$3d8d29fb8a8873dc;
module.exports["CommentButton"] = $8c4374cc7c888870$export$44a3d5aec3da3e9f;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("f34lU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $gj7hi = parcelRequire("gj7hi");


var $iXCQx = parcelRequire("iXCQx");

var $aa277faa111672e8$exports = {};
$aa277faa111672e8$exports = new URL("lightModeInlineComment.308e6718.gif", import.meta.url).toString();


var $6840bfdf996b7ad4$exports = {};
$6840bfdf996b7ad4$exports = new URL("darkModeInlineComment.186fb503.gif", import.meta.url).toString();


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba073fcc81246a1a$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt44ar7 _1bsbn8ye _4t3i1ijo _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _12nx1af2 _nd4uutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ba073fcc81246a1a$var$formattedMessageValues = {
    b: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong"
        }, str)
};
const $ba073fcc81246a1a$export$92cbfa6069f06fe8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba073fcc81246a1a$var$ContentContainer, {
        "data-cy": "inline-comment-gif"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "inline-comments-common.heading",
        defaultMessage: "Be the first to add an inline comment",
        tagName: "h1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: `${(0, (/*@__PURE__*/$parcel$interopDefault($aa277faa111672e8$exports)))}?${new Date().getTime()}`,
        srcDark: `${(0, (/*@__PURE__*/$parcel$interopDefault($6840bfdf996b7ad4$exports)))}?${new Date().getTime()}`,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "inline-comments-common.message",
        defaultMessage: "Share your feedback or ask a question by highlighting text and selecting <b>Comment</b>.",
        tagName: "p",
        values: $ba073fcc81246a1a$var$formattedMessageValues
    }));
module.exports["inlineCommentGifContent"] = $ba073fcc81246a1a$export$92cbfa6069f06fe8;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("5UIqj"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("7OXmP"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("le8BW"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network'
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<9576c4641d6e53de65b0b62ec71933b2>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("5UIqj", function(module, exports) {

let $44e4a44c73377ca9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $44e4a44c73377ca9$var$load("5vfHd"),
    $44e4a44c73377ca9$var$load("2Stk7"),
    $44e4a44c73377ca9$var$load("evYW1"),
    $44e4a44c73377ca9$var$load("3Bbwl"),
    $44e4a44c73377ca9$var$load("7EorR"),
    $44e4a44c73377ca9$var$load("9AXkC"),
    $44e4a44c73377ca9$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("7OXmP", function(module, exports) {

let $5b1b4105ca758294$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b1b4105ca758294$var$load("kHOMt"),
    $5b1b4105ca758294$var$load("9AXkC"),
    $5b1b4105ca758294$var$load("5vfHd"),
    $5b1b4105ca758294$var$load("2Stk7"),
    $5b1b4105ca758294$var$load("6wr18"),
    $5b1b4105ca758294$var$load("ffEVr"),
    $5b1b4105ca758294$var$load("gYeBT"),
    $5b1b4105ca758294$var$load("8LtYa"),
    $5b1b4105ca758294$var$load("9qN8n"),
    $5b1b4105ca758294$var$load("g9CVe"),
    $5b1b4105ca758294$var$load("3JSgG"),
    $5b1b4105ca758294$var$load("70IPm"),
    $5b1b4105ca758294$var$load("hvsDR"),
    $5b1b4105ca758294$var$load("9t4BV"),
    $5b1b4105ca758294$var$load("evYW1"),
    $5b1b4105ca758294$var$load("h3ABO"),
    $5b1b4105ca758294$var$load("kC80R"),
    $5b1b4105ca758294$var$load("7EorR"),
    $5b1b4105ca758294$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("le8BW", function(module, exports) {

let $f74195c047bb903a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f74195c047bb903a$var$load("h3ABO"),
    $f74195c047bb903a$var$load("fPSgL"),
    $f74195c047bb903a$var$load("6wr18"),
    $f74195c047bb903a$var$load("bfveI"),
    $f74195c047bb903a$var$load("1GCFv"),
    $f74195c047bb903a$var$load("4l6RQ"),
    $f74195c047bb903a$var$load("cLmw6"),
    $f74195c047bb903a$var$load("lNrIG"),
    $f74195c047bb903a$var$load("dvUU0"),
    $f74195c047bb903a$var$load("1H5IN"),
    $f74195c047bb903a$var$load("a9w2G"),
    $f74195c047bb903a$var$load("gYeBT"),
    $f74195c047bb903a$var$load("iGCP8"),
    $f74195c047bb903a$var$load("8VT23"),
    $f74195c047bb903a$var$load("6cnH1"),
    $f74195c047bb903a$var$load("lkOIY"),
    $f74195c047bb903a$var$load("dI1Cd"),
    $f74195c047bb903a$var$load("jbxHq"),
    $f74195c047bb903a$var$load("l0dTs"),
    $f74195c047bb903a$var$load("8YSo7"),
    $f74195c047bb903a$var$load("7do1E"),
    $f74195c047bb903a$var$load("77dkW"),
    $f74195c047bb903a$var$load("9ijrN"),
    $f74195c047bb903a$var$load("Wowvf"),
    $f74195c047bb903a$var$load("3JSgG"),
    $f74195c047bb903a$var$load("cyGuT"),
    $f74195c047bb903a$var$load("ffEVr"),
    $f74195c047bb903a$var$load("9AXkC"),
    $f74195c047bb903a$var$load("28arV"),
    $f74195c047bb903a$var$load("hhss7"),
    $f74195c047bb903a$var$load("bv575"),
    $f74195c047bb903a$var$load("1uucB"),
    $f74195c047bb903a$var$load("1cktr"),
    $f74195c047bb903a$var$load("3Oy4g"),
    $f74195c047bb903a$var$load("70IPm"),
    $f74195c047bb903a$var$load("hvsDR"),
    $f74195c047bb903a$var$load("9t4BV"),
    $f74195c047bb903a$var$load("f1Pmi"),
    $f74195c047bb903a$var$load("03cA3"),
    $f74195c047bb903a$var$load("5qNrc"),
    $f74195c047bb903a$var$load("dP7ao"),
    $f74195c047bb903a$var$load("hogcU"),
    $f74195c047bb903a$var$load("31vk5"),
    $f74195c047bb903a$var$load("5vfHd"),
    $f74195c047bb903a$var$load("2Stk7"),
    $f74195c047bb903a$var$load("2uVTT"),
    $f74195c047bb903a$var$load("fGkaB"),
    $f74195c047bb903a$var$load("kc8tx"),
    $f74195c047bb903a$var$load("evYW1"),
    $f74195c047bb903a$var$load("hrqeu"),
    $f74195c047bb903a$var$load("8ublV"),
    $f74195c047bb903a$var$load("3DgZV"),
    $f74195c047bb903a$var$load("8oy3N"),
    $f74195c047bb903a$var$load("9lOYK"),
    $f74195c047bb903a$var$load("7EorR"),
    $f74195c047bb903a$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("hzHOC", function(module, exports) {
/* CommentIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $1yB28 = parcelRequire("1yB28");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $gnkil = parcelRequire("gnkil");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");

const $c059b1adf8cf4575$export$44b2fb99348acd1a = (editorEmitter, handleCommentButtonClick)=>{
    if (document.getElementById('editor-comments-sidebar')) editorEmitter.emit('setselectedannotation', '');
    else handleCommentButtonClick();
};
const $c059b1adf8cf4575$export$ca142aafa48f4ac5 = (editorEmitter, handleCommentButtonClick, editorViewProps, setEditorViewProps)=>{
    // If we aren't showing/creating a comment trigger the comment button click
    if (!editorViewProps) handleCommentButtonClick();
    else {
        // Otherwise, close the comment
        editorEmitter.emit('setselectedannotation', '');
        setEditorViewProps(null);
    }
};


const $1f8a245ef41c52a4$var$CommentButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $1f8a245ef41c52a4$var$CommentTooltipText = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment-button.tooltip",
        defaultMessage: "Show comments"
    });
};
const $1f8a245ef41c52a4$export$a3543c9c8473fb3d = ({ triggerProps: triggerProps, intl: intl, handleCommentButtonClick: handleCommentButtonClick, commentButtonRef: commentButtonRef, isDisabled: isDisabled = false, pageMode: pageMode = 'view' })=>{
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' && !isLiveViewMode
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1f8a245ef41c52a4$var$CommentButtonWrapper, {
        "data-testid": "comment-icon",
        ref: commentButtonRef,
        "data-vc": "comment-icon"
    }, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: ()=>{
            if (document.getElementById('renderer-comments-sidebar')) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            } else handleCommentButtonClick();
        }
    }), pageMode === 'edit' && !isLiveViewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: ()=>{
            // This has to live here so it can be globally listened to, if we put it inside of
            // the sidebar, then it will only trigger when the sidebar has focus
            if ((0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager')) {
                // If the content has changed in view, ask the user if they want to discard
                if (editorViewProps && hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        (0, $c059b1adf8cf4575$export$ca142aafa48f4ac5)(editorEmitter, handleCommentButtonClick, editorViewProps, setEditorViewProps);
                    }
                });
                else (0, $c059b1adf8cf4575$export$ca142aafa48f4ac5)(editorEmitter, handleCommentButtonClick, editorViewProps, setEditorViewProps);
            } else (0, $c059b1adf8cf4575$export$44b2fb99348acd1a)(editorEmitter, handleCommentButtonClick);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1f8a245ef41c52a4$var$CommentTooltipText, null),
        shortcut: commentShortcutStrings,
        hideTooltipOnClick: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "comment-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            spacing: "spacious",
            label: intl.formatMessage({
                id: "comment-button.icon.label",
                defaultMessage: "Show comments"
            })
        }),
        isDisabled: isDisabled,
        onClick: handleCommentButtonClick,
        ...triggerProps || {}
    })));
};
module.exports["CommentIcon"] = $1f8a245ef41c52a4$export$a3543c9c8473fb3d;

});


//# sourceMappingURL=CommentButton.08468ecf.js.map
